import { IPermission } from './../models/permission';
import { ApiUtility } from './../utilities/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ICalendarEventCategory } from '../models/category';
import { ICalendarEvent } from '../models/event';

export const calendarApi = createApi({
  reducerPath: 'calendar',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/calendar'
  }),
  endpoints: build => ({
    saveRequestChanges: build.mutation<void, { calendarEventId: number, requestChange: string }>({
      query: (params) => ({
        url: 'saveRequestChanges',
        method: 'POST',
        body: params
      })
    }),
    saveEvent: build.mutation<void, { id: number; newEvent: ICalendarEvent }>({
      query: ({ id, newEvent }) => ({
        url: 'saveEvent?calendarNodeId=' + id,
        method: 'POST',
        body: newEvent
      })
    }),
    getCategories: build.query<Array<ICalendarEventCategory>, number>({
        query: id => ({
            url: 'getCategories?calendarNodeId=' + id,
            method: 'POST'
      })
    }),
    getEvents: build.mutation<Array<Object>, { [key: string]: any }>({
      query: ({
        filter,
        categoryIds = null,
        calendarNodeId,
        startDateInput = null,
        endDateInput = null,
        pageIndex = null,
        pageSize = null
      }) => ({
        url: `getEvents${ApiUtility.getQueryParams(
          {
            filter,
            categoryIds,
            calendarNodeId,
            startDateInput,
            endDateInput,
            pageIndex,
            pageSize
          },
          true
        )}`,
        method: 'POST'
      })
    }),
    getPermissionOnCalendar: build.query<IPermission, number>({
      query: id => ({
        url: 'getPermissionOnCalendar?calendarNodeId=' + id,
        method: 'POST'
      })
    }),
    getPermissionOnEvent: build.query<IPermission, number>({
      query: id => ({
        url: 'getPermissionOnEvent?eventId=' + id,
        method: 'POST'
      })
    })
  })
});
